(() => {
  const RESUME_ON_MANUAL_NAV = true;

  const getF = (sliderEl) => sliderEl?.slider;
  const isPlaying = (sliderEl) => getF(sliderEl)?.player?.state === "playing";

  function ensurePaused(sliderEl) {
    setTimeout(() => {
      if (isPlaying(sliderEl)) {
        getF(sliderEl)?.pausePlayer?.();
      }
    }, 60);
  }
  function ensurePlaying(sliderEl) {
    setTimeout(() => {
      if (!isPlaying(sliderEl)) {
        getF(sliderEl)?.playPlayer?.();
      }
    }, 60);
  }

  const speedMs = (sliderEl) => {
    const raw = sliderEl?.getAttribute("autoplay-speed");
    if (!raw) return 5000;
    const n = Number(raw);
    return n > 20 ? n : Math.max(1, n) * 1000;
  };

  const selectedIndex = (sliderEl, section) => {
    if (sliderEl?.slider && Number.isFinite(sliderEl.slider.selectedIndex)) {
      return sliderEl.slider.selectedIndex;
    }
    const fromAttr = Number(sliderEl?.getAttribute("selected-index"));
    if (Number.isFinite(fromAttr)) return fromAttr;

    if (section) {
      const words = section.querySelector(
        `slideshow-words[aria-controls="${sliderEl?.id}"]`
      );
      const cur = words?.querySelector('[aria-current="true"]');
      const fromWords = Number(cur?.getAttribute("data-index"));
      if (Number.isFinite(fromWords)) return fromWords;
    }
    return 0;
  };

  const syncDots = (section, sliderEl) => {
    const idx = selectedIndex(sliderEl);
    section
      .querySelectorAll(`slider-dots[aria-controls="${sliderEl.id}"]`)
      .forEach((wrap) => {
        wrap.querySelectorAll(".flickity-page-dot").forEach((b) => {
          const bi = Number(b.getAttribute("data-index"));
          if (Number.isFinite(bi)) {
            b.setAttribute("aria-current", bi === idx ? "true" : "false");
          }
        });
      });
  };

  const getSlides = (sliderEl) => {
    if (Array.isArray(sliderEl?.items)) return sliderEl.items;
    if (sliderEl?.items && typeof sliderEl.items.length === "number")
      return sliderEl.items;
    return Array.from(sliderEl?.querySelectorAll(":scope > .banner") || []);
  };

  const currentSlide = (sliderEl, section) => {
    const slides = getSlides(sliderEl);
    const i = selectedIndex(sliderEl, section);
    return slides[i] || null;
  };

  const visibleEl = (root, sel) => {
    const els = Array.from(root.querySelectorAll(sel));
    return (
      els.find((el) => {
        const r = el.getBoundingClientRect();
        return r.width > 1 && r.height > 1;
      }) || null
    );
  };

  const findMedia = (slideEl) => {
    if (!slideEl) return { wrap: null, videoMedia: null, video: null };
    const wrap =
      slideEl.querySelector(".video-wrap") ||
      slideEl.querySelector("video-media") ||
      slideEl.querySelector(".banner__media") ||
      slideEl;
    const videoMedia = visibleEl(slideEl, "video-media");
    const video = visibleEl(slideEl, "video");
    return { wrap, videoMedia, video };
  };

  const pauseMedia = (sliderEl) => {
    try {
      const section = sliderEl.closest(".shopify-section");
      const slide = currentSlide(sliderEl, section);
      if (!slide) {
        return;
      }

      const { wrap, videoMedia, video } = findMedia(slide);

      const target = videoMedia || wrap || slide;

      if (window.UnifiedVideo?.pauseMedia) {
        try {
          window.UnifiedVideo.pauseMedia(target);
        } catch {}
      }

      if (videoMedia?.pause) videoMedia.pause();
      video?.pause?.();
    } catch {}
  };

  const playMedia = (sliderEl) => {
    try {
      const section = sliderEl.closest(".shopify-section");
      const slide = currentSlide(sliderEl, section);
      if (!slide) {
        return;
      }

      const { wrap, videoMedia, video } = findMedia(slide);
      const target = videoMedia || wrap || slide;

      if (window.UnifiedVideo?.playMedia) {
        try {
          window.UnifiedVideo.playMedia(target);
        } catch {}
      }

      if (videoMedia?.play) videoMedia.play();
      video?.play?.().catch(() => {});
    } catch {}
  };

  const waitForFlickity = (sliderEl, cb) => {
    let tries = 0;
    const tryIt = () => {
      if (sliderEl.slider) return cb();
      if (tries++ > 300) return;
      requestAnimationFrame(tryIt);
    };
    tryIt();
  };

  const wire = (sliderEl) => {
    const section = sliderEl.closest(".shopify-section");
    if (!section) return;

    const btn = section.querySelector(".slideshow-controls.br-cluster .pp-btn");
    if (!btn || btn.__ringInit) return;

    btn.__ringInit = true;
    const fg = btn.querySelector(".pp-ring__fg");
    let C = null;
    if (fg) {
      const r = fg.r?.baseVal?.value || Number(fg.getAttribute("r")) || 20;
      C = 2 * Math.PI * r;
      fg.setAttribute("stroke-dasharray", String(C));
      fg.setAttribute("stroke-dashoffset", String(C));
      fg.style.transform = "rotate(-90deg)";
      fg.style.transformOrigin = "50% 50%";
    }
    const setRing = (p01) => {
      if (!fg || !C) return;
      const p = Math.max(0, Math.min(1, p01));
      fg.setAttribute("stroke-dashoffset", String(C * (1 - p)));
    };

    let playing = sliderEl.hasAttribute("autoplay");
    sliderEl.addEventListener("slider:play", () => {
      playing = true;
    });
    sliderEl.addEventListener("slider:pause", () => {
      playing = false;
    });

    let raf = null,
      t0 = 0,
      ms = speedMs(sliderEl);

    const stopRAF = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = null;
    };
    const startRAF = () => {
      stopRAF();
      ms = speedMs(sliderEl);
      t0 = performance.now();
      setRing(0);
      const tick = (now) => {
        if (!playing) {
          raf = requestAnimationFrame(tick);
          return;
        }
        const p = ((now - t0) / ms) % 1;
        setRing(p);
        raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    };

    const playSlider = () =>
      sliderEl.dispatchEvent(new CustomEvent("slider:play", { bubbles: true }));
    const pauseSlider = () =>
      sliderEl.dispatchEvent(
        new CustomEvent("slider:pause", { bubbles: true })
      );

    const iconEl = () => btn.querySelector(".pp-icon");
    const labelEl = () => btn.querySelector(".sr-only");

    const hardPause = () => {
      sliderEl.dispatchEvent(
        new CustomEvent("slider:pause", { bubbles: true })
      );
      sliderEl.slider?.pausePlayer?.();
      pauseMedia(sliderEl);
      playing = false;
      btn.setAttribute("aria-pressed", "true");
      btn.setAttribute("aria-label", "Play slideshow");

      const icon = iconEl();
      if (icon) {
        const p = icon.querySelector(".icon-pause");
        const s = icon.querySelector(".icon-play");
        if (p) p.style.display = "none";
        if (s) s.style.display = "inline";
      }

      const lab = labelEl();
      if (lab) lab.textContent = "Play";
    };

    const hardPlay = () => {
      sliderEl.dispatchEvent(new CustomEvent("slider:play", { bubbles: true }));
      sliderEl.slider?.playPlayer?.();
      playMedia(sliderEl);
      playing = true;
      playing = true;
      btn.setAttribute("aria-pressed", "false");
      btn.setAttribute("aria-label", "Pause slideshow");

      const icon = iconEl();
      if (icon) {
        const p = icon.querySelector(".icon-pause");
        const s = icon.querySelector(".icon-play");
        if (p) p.style.display = "inline";
        if (s) s.style.display = "none";
      }

      const lab = labelEl();
      if (lab) lab.textContent = "Pause";

      startRAF();
    };

    btn.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        btn.blur();
        playing ? hardPause() : hardPlay();
      },
      { passive: false }
    );

    const nextBtn = section.querySelector(
      `button[is="next-button"][aria-controls="${sliderEl.id}"]`
    );
    const prevBtn = section.querySelector(
      `button[is="previous-button"][aria-controls="${sliderEl.id}"]`
    );
    const onManualNav = () => {
      if (!RESUME_ON_MANUAL_NAV) return;
      if (!playing) hardPlay();
    };
    if (nextBtn && !nextBtn.__ringNav) {
      nextBtn.__ringNav = true;
      nextBtn.addEventListener("click", onManualNav, { passive: true });
    }
    if (prevBtn && !prevBtn.__ringNav) {
      prevBtn.__ringNav = true;
      prevBtn.addEventListener("click", onManualNav, { passive: true });
    }

    sliderEl.addEventListener("slider:change", () => {
      syncDots(section, sliderEl);
      if (playing) {
        playMedia(sliderEl);
        startRAF();
      } else {
        pauseMedia(sliderEl);
        stopRAF();
      }
    });

    new MutationObserver((muts) => {
      if (muts.some((m) => m.attributeName === "autoplay-speed")) {
        if (playing) startRAF();
      }
    }).observe(sliderEl, {
      attributes: true,
      attributeFilter: ["autoplay-speed"],
    });

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        stopRAF();
      } else if (playing) {
        startRAF();
      }
    });

    waitForFlickity(sliderEl, () => {
      syncDots(section, sliderEl);
      if (playing) startRAF();

      if (playing) playMedia(sliderEl);
    });
  };

  const runAll = () => {
    document.querySelectorAll('slideshow-element[id^="Slider-"]').forEach(wire);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runAll, { once: true });
  } else {
    runAll();
  }
  document.addEventListener("shopify:section:load", runAll);
  document.addEventListener("shopify:section:select", runAll);
})();
